import { useCallback, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { ANALYTICS_EVENTS } from '@/core/analytics'
import useAnalytics from '../useAnalytics'
import { PAGE_TITLE, EXCLUDED_PATHS } from './AnalyticsProvider.data'

export const useAnalyticsProviderController = () => {
  const location = useLocation()
  const { sendAnalytics } = useAnalytics()

  const trackPageView = useCallback(
    (pathName: string) => {
      if (EXCLUDED_PATHS.includes(pathName)) return

      const pageTitle = PAGE_TITLE[pathName] ?? document.title

      sendAnalytics(ANALYTICS_EVENTS.EVENT_TYPES.PAGE_VIEW, {
        page_location: window.location.href,
        page_title: pageTitle,
      })
    },
    [sendAnalytics],
  )

  useEffect(() => {
    trackPageView(location.pathname)
  }, [trackPageView, location.pathname])

  return { trackPageView }
}
